export const licenseKey =
  "ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjZkZGI0YTE1LTBjNzktNGFhMC04ODM4LTQ1ZTJlM2E2ZGEzZCIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQyCn0=.Z0KkD6vxPgwPHkHB2Fv4L31iqP2qHf2d3Folb8HZ/YMgK9D8/S84ImLn4W8kZxhonUYqM7WZg2gzecGmGRzWBhAXzA/Ecp2ImhNpqIwdknO8+ojQpQ1ekVzh+iZ5Oe7qkf+66w==";
